import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { Globe } from 'lucide-react'
import { Modal } from '@blackjackfun/ui-components'
import { RadioButton } from '@src/components/Elements/RadioButton/RadioButton'
import MenuItem from '@src/components/Elements/MenuItem/MenuItem'

export const LanguageSelector = ({ collapsedMenu }: { collapsedMenu: boolean }) => {
  const { t, i18n } = useTranslation()
  const [open, setOpen] = useState(false)
  const [choosenLanguage, setChoosenLanguage] = useState(i18n.language)

  // Define available languages with their properties
  const languages = [
    { code: 'en', label: t('languageSelector.en', 'English'), flag: '🇺🇸' },
    { code: 'pt', label: t('languageSelector.pt', 'Portuguese'), flag: '🇧🇷' },
    { code: 'ja', label: t('languageSelector.ja', 'Japanese'), flag: '🇯🇵' },
  ]
  const getLanguageLabel = (code: string) => languages.find((lang) => lang.code === code) || languages[0]
  const currentLanguage = getLanguageLabel(choosenLanguage)

  useEffect(() => {
    setChoosenLanguage(i18n.language)
  }, [i18n.language])

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleChangeLanguage = (code: string) => {
    i18n.changeLanguage(code)
    setOpen(false)
  }

  return (
    <div>
      <MenuItem
        isCollapsed={collapsedMenu}
        isActive={false}
        icon={<Globe size={16} />}
        label={currentLanguage.label}
        linkPath={`#`}
        isExpanded={true}
        onLinkClick={handleOpen}
      />

      <Modal
        isOpen={open}
        onClose={handleClose}
        closeButton={true}
        title={t('languageSelector.select', 'Select Language')}
        contents={
          <>
            {languages.map((lang) => (
              <RadioButton
                $bg={true}
                key={lang.code}
                label={`${lang.flag} ${lang.label} (${lang.code.toUpperCase()})`}
                selected={i18n.language === lang.code}
                onClick={() => handleChangeLanguage(lang.code)}
              />
            ))}
          </>
        }
      />
    </div>
  )
}
